import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * Talks to this app's own backend (GET /toola-sync/status), which proxies the
 * toola-connector. Auth token is attached by the global AuthInterceptor.
 */
@Injectable({ providedIn: 'root' })
export class ToolaSyncService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getStatus(clientId?: string): Observable<any> {
    const url =
      `${this.baseUrl}/toola-sync/status` +
      (clientId ? `?clientId=${encodeURIComponent(clientId)}` : '');
    return this.http.get(url);
  }

  getItems(
    status?: string,
    clientId?: string,
    storeId?: string,
    date?: string,
  ): Observable<any> {
    const q: string[] = [];
    if (status) q.push(`status=${encodeURIComponent(status)}`);
    if (clientId) q.push(`clientId=${encodeURIComponent(clientId)}`);
    if (storeId) q.push(`storeId=${encodeURIComponent(storeId)}`);
    if (date) q.push(`date=${date}`);
    return this.http.get(
      `${this.baseUrl}/toola-sync/items${q.length ? '?' + q.join('&') : ''}`,
    );
  }

  /** Store/date reconciliation: sales vs posted. */
  getRecon(from?: string, to?: string, clientId?: string): Observable<any> {
    const q: string[] = [];
    if (from) q.push(`from=${from}`);
    if (to) q.push(`to=${to}`);
    if (clientId) q.push(`clientId=${encodeURIComponent(clientId)}`);
    return this.http.get(
      `${this.baseUrl}/toola-sync/recon${q.length ? '?' + q.join('&') : ''}`,
    );
  }
}
